export { default } from './VideoTag';



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/VideoTag/index.js
 **/